module.exports = __webpack_public_path__ + "img/mnms2.23dde76b.png";